/**
 * Asynchronously loads the component for EmailTemplatesCreateEditPage
 */

import { lazyLoad } from 'utils/loadable';

export const EmailTemplatesCreateEditPage = lazyLoad(
  () => import('./index'),
  module => module.EmailTemplatesCreateEditPage,
);
